/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ReviewStatus = {
  type: 'Enum',
} as const;
